const disputeClaimsDE = {
    "view": {
        "table": {
            "title": "Ihre Urheberrechtsverletzungen",
            "columns": {
                "release": "Veröffentlichung",
                "user": "Benutzer",
                "store": "Shop",
                "claimantName": "Name des Anspruchstellers",
                "claimantEmail": "E-Mail des Anspruchstellers",
                "resolutionTime": "Lösungszeit",
                "remainingTime": "Verbleibende Zeit",
                "status": "Status"
            },
            "label": {
                "status_created": "Erstellt",
                "status_pending": "Ausstehend",
                "status_in_progress": "In Bearbeitung",
                "status_resolved": "Gelöst",
                "status_copyright_violation": "Urheberrechtsverletzung"
            },
            "button": {
                "exportCSV": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suchen..."
            }
        }
    }
};

export default disputeClaimsDE;